
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/pmm-complete-guide/done",
      function () {
        return require("private-next-pages/download/pmm-complete-guide/done/index.tsx");
      }
    ]);
  